import { userConstants } from '../constants/user.constants';
import { history } from '../../utils/history';

const storage =
  typeof window !== 'undefined' && window.localStorage ? window.localStorage : null;

let user = null;
let foundUser = null;
let organizationId = null;
let foundPractitioner = null;
let foundTeams = [];
const roleOrganizationIds = [];

if (storage) {
  try {
    user = JSON.parse(storage.getItem('token'));
    foundTeams = JSON.parse(storage.getItem('teams')) || [];
    foundUser = JSON.parse(storage.getItem('user')) || {};
    const localPractitioner = storage.getItem('practitioner');

    if (localPractitioner && localPractitioner !== 'undefined') {
      foundPractitioner = JSON.parse(localPractitioner);
      organizationId = foundPractitioner.organizationId;
    }
  } catch (e) {
    storage.clear();
    console.error(
      "[AUTHENTICATION ERROR]: couldn't parse the localstorage data. CLEARED LOCAL STORAGE",
    );
    history.push('/login');
  }
}

const isAdmin = (role) => {
  const adminRoles = ['super-admin'];
  return adminRoles.includes(role);
};

const isDeviceAdmin = (roles) => {
  const deviceAdminRoles = ['device-admin'];
  return (roles || [])
    .map((item) => item.roleName)
    .some((item) => deviceAdminRoles.includes(item));
};

const isDeviceManager = (roles) => {
  const deviceManagerRoles = ['device-manager'];
  return (roles || [])
    .map((item) => item.roleName)
    .some((item) => deviceManagerRoles.includes(item));
};

const isLogisticsAdmin = (roles) => {
  const logisticsAdminRoles = ['logistics-admin'];
  return (roles || [])
    .map((item) => item.roleName)
    .some((item) => logisticsAdminRoles.includes(item));
};

const canManageTeams = (role) => {
  const adminRoles = ['super-admin', 'organization-manager', 'logistics-admin'];
  return adminRoles.includes(role);
};

const checkManageableOrganization = (roles) =>
  (roles || [])
    .map((role) => {
      const { organizationId, roleName } = role;
      roleOrganizationIds.push(organizationId);
      if (canManageTeams(roleName)) {
        return organizationId;
      }
      return null;
    })
    .filter((item) => item);

const { roleName, 'role-assignment': roles } = foundUser || {};
const organizationIds = checkManageableOrganization(roles);

const initialState = user
  ? {
      loggedIn: true,
      user,
      foundUser,
      teams: foundTeams,
      practitioner: foundPractitioner
        ? { ...foundPractitioner, isActiveProdSub: true }
        : null,
      loggingIn: false,
      userIsAdmin: isAdmin(roleName),
      isLogisticsAdmin: isLogisticsAdmin(roles),
      isDeviceAdmin: isDeviceAdmin(roles),
      isDeviceManager: isDeviceManager(roles),
      canManageTeams: canManageTeams(roleName),
      manageableOrganizationIds: organizationIds,
      organizationId: organizationId || [...new Set(roleOrganizationIds)][0],
      roles,
      roleName,
    }
  : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        ...state,
        loggingIn: true,
        user: action.user,
      };
    case userConstants.LOGIN_SUCCESS: {
      const { login, user, practitioner, teams, userHash } = action.user;
      storage?.setItem('token', JSON.stringify(login));
      storage?.setItem('intercom-user-hash', JSON.stringify(userHash));
      const roles = user?.['role-assignment'] || [];
      const { roleName } = user?.['role-assignment'][0] || {};
      user.roleName = roleName;
      storage?.setItem('user', JSON.stringify(user));
      storage?.setItem('practitioner', JSON.stringify(practitioner));
      storage?.setItem('teams', JSON.stringify(teams || []));
      const possibleOrganizationIds = roles.map((role) => role.organizationId);
      const possibleOrganizationId =
        foundUser?.organizationId || [...new Set(possibleOrganizationIds)][0];
      return {
        ...state,
        user: login,
        foundUser: user,
        loggingIn: false,
        userIsAdmin: isAdmin(roleName),
        isDeviceAdmin: isDeviceAdmin(roles),
        isDeviceManager: isDeviceManager(roles),
        isLogisticsAdmin: isLogisticsAdmin(roles),
        canManageTeams: canManageTeams(roles),
        manageableOrganizationIds: checkManageableOrganization(roles),
        organizationId: possibleOrganizationId,
        teams,
        practitioner: practitioner
          ? { ...practitioner, isActiveProdSub: true }
          : null,
        roleName,
        roles,
      };
    }
    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        loggingIn: false,
      };
    case userConstants.UPDATE_EMAIL_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case userConstants.UPDATE_EMAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case userConstants.UPDATE_EMAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case userConstants.LOGOUT:
      return {
        ...state,
        loggedIn: false,
        loggingIn: false,
      };

    case userConstants.SET_PRACTITIONER_PRODUCT_SUB:
      const { isActiveSub } = action.payload;
      return {
        ...state,
        ...(state?.practitioner && {
          practitioner: {
            ...state.practitioner,
            isActiveProdSub: isActiveSub,
          },
        }),
      };

    default:
      return state;
  }
}
